// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InvoiceLineItem } from '@/billing/api/types';
import { formatCurrencyValue } from '@/currency/utilities/format';
import { formatShortDate } from '@/utilities/date-time';
import { formatNumber } from '@/utilities/number';
import { TableCell, TableRow, Typography } from '@mui/material';

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface ReadOnlyLineItemRowProps {
  lineItem: InvoiceLineItem;
  index: number;
}

// ---------------------------------------------------------------------------
// Read-only row
// ---------------------------------------------------------------------------

export function ReadOnlyLineItemRow(props: ReadOnlyLineItemRowProps) {
  const { lineItem, index } = props;
  const servicePeriod =
    lineItem.servicePeriodStart && lineItem.servicePeriodEnd
      ? `${formatShortDate(lineItem.servicePeriodStart)} – ${formatShortDate(lineItem.servicePeriodEnd)}`
      : '—';

  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{lineItem.description}</TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {servicePeriod}
        </Typography>
      </TableCell>
      <TableCell align="right">{formatNumber(lineItem.quantity)}</TableCell>
      <TableCell align="right">
        {lineItem.unitPrice !== null
          ? formatCurrencyValue(lineItem.unitPrice, { sparse: true })
          : '—'}
      </TableCell>
      <TableCell align="right">
        {formatCurrencyValue(lineItem.totalPrice, { sparse: true })}
      </TableCell>
      <TableCell align="right">
        {lineItem.taxAmount !== null
          ? formatCurrencyValue(lineItem.taxAmount, { sparse: true })
          : '—'}
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight="bold">
          {formatCurrencyValue(lineItem.lineTotal)}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
